import { OpenLocationCode } from 'open-location-code'

const plusCodeGenerator = new OpenLocationCode()

/**
 * Generate a Plus Code from coordinates.
 */
export function generatePlusCode(lat: number, lng: number): string {
  return plusCodeGenerator.encode(lat, lng)
}
